type Params = {
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
};

type EdgePosition = {
  midX: number;
  midY: number;
};

const getEdgePosition = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
}: Params): EdgePosition => {
  const offsetX = (targetX - sourceX) / 2;
  const offsetY = (targetY - sourceY) / 2;

  return {
    midX: sourceX + offsetX,
    midY: sourceY + offsetY,
  };
};

export default getEdgePosition;
